export const APP_NAVIGATION = [
    { name: 'General Settings', href: '/settings', current: true },
    { name: 'LLM', href: '/llm', current: false },
    { name: 'Voice AI', href: '/voice', current: false },
    { name: 'Agent Settings', href: '/agent/settings', current: false },
    { name: 'Access Keys', href: '/access-keys', current: false },
    { name: 'Versions', href: '/versions', current: false },
];

export const AGENT_NAVIGATION = [
    { name: 'Agent', href: '/agent', current: true },
    { name: 'Tools', href: '/tools', current: false }
];
